<template>
  <div
    v-tooltip="{
      content: tooltipContent,
      placement: 'bottom',
      onShow: () => !isMobile,
    }"
    class="watch-icon-wrap pt usn group"
    :class="{ 'disabled-item': archived }"
    @click="handleClick"
  >
    <em
      :style="getCustomIconStyle(iconPath(isWatching ? 'bell-filled' : 'bellv1'))"
      class="custom-icons watch-icon"
      :class="{
        watching: isWatching,
        'disabled-item': archived,
        'group-hover:bg-icon-hover bg-icon-default': !isWatching,
      }"
    />
    <span
      v-if="watchersCount"
      class="watchers-count"
    >
      {{ watchersCount }}
    </span>
  </div>
</template>

<script>
import watchMixin from '@/mixins/watchMixin';
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  name: 'WatchIcon',
  mixins: [watchMixin, customIconsMixin],
  props: {
    resource: {
      type: Object,
      required: true,
    },
    resourceSection: {
      type: String,
      required: true,
    },
    archived: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    tooltipContent() {
      return this.isWatching ? this.translate('unsubscribe') : this.translate('subscribe');
    },

    isWatching() {
      return this.resource.is_watching;
    },

    watchersCount() {
      return 0;
    },
  },
  methods: {
    handleClick() {
      this.toggleWatch(this.isWatching, this.resourceSection, this.resource.id);
    },
  },
};
</script>

<style lang="scss">
.watch-icon-wrap {
  display: flex;
  align-items: center;

  .watchers-count {
    letter-spacing: 0.3px;
    font-size: 14px;
    line-height: 19px;
    color: $gray600;
    margin-left: 8px;
  }

  &.disabled-item {
    @apply pointer-events-none #{!important};
  }

  em {
    &.disabled-item {
      @apply bg-gray-300;
    }
  }
}
</style>
